import Experience from '../Experience';
import * as THREE from 'three';
import scene from 'three/examples/jsm/offscreen/scene';

export default class Environment {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;

        this.setLights();
        this.loadEnvironmentalMap();
    }

    setLights() {
        this.directionalLight = new THREE.DirectionalLight(0x7BD7FF, 1);
        this.directionalLight.castShadow = true;
        this.directionalLight.shadow.normalBias = 0.05;
        this.scene.add(this.directionalLight);

        // const ambientLight = new THREE.AmbientLight(0xffffff, 0);
        // this.scene.add(ambientLight);

        // this.headLight1 = new THREE.SpotLight(0xffffff, 10, 10, Math.PI * 0.1, 1, 1);
        // this.headLight1.position.set(0.460091, 0.499367, 1.65362);
        // this.headLight1.target.position.set(0.460091, 0, 4 );
        //
        // this.headLight2 = new THREE.SpotLight(0xffffff, 10, 10, Math.PI * 0.1, 1, 1);
        // this.headLight2.position.set(-0.38058, 0.499367, 1.65362);
        // this.headLight2.target.position.set( -0.38058, 0, 4 );

        // this.moonLight = new THREE.SpotLight(0xFFD997, 10, 5, Math.PI * 0.07, 1, 1);
        // this.moonLight.position.set(0.077943, 2.74012, 3.44767 );
        // this.moonLight.target.position.set( 0, 0, 0 );
        // this.moonLight.castShadow = true;

        // this.saloonLight = new THREE.SpotLight(0xFFD997, 0, 3, Math.PI * 0.07, 1, 1);
        // this.saloonLight.position.set(0.077943, 2.74012, 2 );
        // this.saloonLight.target.position.set( 0, 0, -1.4 );
        // this.saloonLight.castShadow = true;
        // this.saloonLight.shadow.normalBias = 0.05;
        // this.saloonLight.shadow.bias = 0.05;

        this.leftSaloonLight = new THREE.PointLight(0xFFDCAC, 0);
        this.rightSaloonLight = new THREE.PointLight(0xFFDCAC, 0);

        this.leftSaloonLight.castShadow = true;
        this.leftSaloonLight.shadow.normalBias = 0.05;
        this.rightSaloonLight.castShadow = true;
        this.rightSaloonLight.shadow.normalBias = 0.05;

        this.leftSaloonLight.position.set(0.069359 , 0.662319, 0.643316);
        this.rightSaloonLight.position.set(-0.1060312, 0.662319, 0.643316);

        const pointLight1 = new THREE.PointLight(0xFF3400, 0.7);
        const pointLight2 = new THREE.PointLight(0xFF3400, 0.7);

        pointLight1.castShadow = true;
        pointLight1.shadow.normalBias = 0.05;
        pointLight2.castShadow = true;
        pointLight2.shadow.normalBias = 0.05;

        pointLight1.position.set(0.521732, 0.537189, -1.74772);
        pointLight2.position.set(-0.521592, 0.537189, -1.74772);

        // this.scene.add(this.headLight1);
        // this.scene.add(this.headLight1.target);
        //
        // this.scene.add(this.headLight2);
        // this.scene.add(this.headLight2.target);

        this.scene.add(this.leftSaloonLight);
        this.scene.add(this.rightSaloonLight);

        this.scene.add(pointLight1);
        this.scene.add(pointLight2);

        // this.scene.add(this.saloonLight);
        // this.scene.add(this.saloonLight.target);
        //
        // this.scene.add(this.moonLight);
        // this.scene.add(this.moonLight.target);
    }

    loadEnvironmentalMap() {
        this.environmentMapTexture = this.resources.items.environmentMapTextures;
        this.environmentMapTexture.encoding = THREE.sRGBEncoding;
    }

    getEnvironment() {
        return this.environmentMapTexture;
    }

    updateMaterials() {
        this.scene.traverse((child) => {
            if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                child.material.envMap = this.environmentMapTexture;
                child.material.intensity = 1;
            }
        })
    }
}